<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0 overflow-y-auto">

  <!-- STICKY HEADER -->
  <div class="sticky top-0 z-20 bg-zinc-100 dark:bg-zinc-900 py-2">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">

      <!-- LEFT: SEARCH + STATUS -->
      <div class="flex flex-col sm:flex-row gap-2 sm:items-center w-full">

        <!-- SEARCH -->
        <div class="relative w-full sm:w-80">
          <input type="text" (input)="onSearchInput()" [(ngModel)]="search" placeholder="Search..." class="pl-9" />

          <svg class="absolute left-2 top-1/2 -translate-y-1/2 size-5 text-zinc-400"
            xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke-width="1.5" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
          </svg>
        </div>

        <!-- STATUS FILTER -->
        <select class="w-full sm:w-40" [(ngModel)]="selectedStatus" (change)="onSelectStatus()">
          <option value="true">Active</option>
          <option value="false">Inactive</option>
        </select>

        <!-- video status -->
        <select class="w-full sm:w-40" [(ngModel)]="type" (change)="onAcademyStatus()">
          <option value="all">All</option>
          <option value="video">Video</option>
          <option value="document">Document</option>
          <option value="file">File</option>
        </select>

      </div>

      <!-- RIGHT: ADD BUTTON -->
      <button *ngIf="permissionService.hasPermission([userPermission.MANAGE_ACADEMY])" class="btn btn-primary whitespace-nowrap" routerLink="add">
        + Add Tutorial
      </button>

    </div>

  </div>

 <!-- GRID -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
  <!-- CARD -->
  <div
    *ngFor="let tutorial of filtertutorialsList | paginate: { itemsPerPage: numberOfRecords, currentPage: currentPage, totalItems: totalResults }"
    class="group bg-white dark:bg-zinc-950 border border-zinc-200 dark:border-zinc-800 rounded-2xl overflow-hidden shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-500 flex flex-col">
  
    <!-- IMAGE -->
      <div class="relative aspect-3/2 overflow-hidden bg-zinc-100 dark:bg-zinc-900">
  
        <img [src]="tutorial.type === 'document' || tutorial.type === 'file' && !tutorial.thumbnailURL ? '/assets/images/document-placeholder.png': tutorial.thumbnailURL"/>

  
      <!-- DARK OVERLAY -->
        <div class="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition duration-500"></div>
      <!-- PLAY BUTTON ON HOVER -->
        <a *ngIf="tutorial.type === 'video'" [href]="tutorial.videoURL" target="_blank" rel="noopener noreferrer"
          class="absolute inset-0 flex items-center justify-center">
      
          <div class="w-14 h-14 rounded-full bg-white shadow-xl flex items-center justify-center
          opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition duration-500">
  
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
              class="w-6 h-6 text-primary ml-1">
  
              <path d="M8 5.14v13.72c0 .77.83 1.25 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z" />
      
            </svg>
      
          </div>
      
        </a>
      
      <a  *ngIf="['document', 'file'].includes(tutorial.type)" [href]="tutorial.videoURL" target="_blank" rel="noopener noreferrer"
        class="absolute inset-0 flex items-center justify-center">
      
        <div class="w-14 h-14 rounded-full bg-white shadow-xl flex items-center justify-center
        opacity-0 scale-75 group-hover:opacity-100 group-hover:scale-100 transition duration-500">
      
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
            class="w-6 h-6 text-primary">
      
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
      
          </svg>
      
        </div>
      
      </a>
      
      </div>
  
    <!-- CONTENT -->
    <div class="p-4 flex flex-col flex-1">
  
      <!-- TITLE -->
      <h2 class="heading line-clamp-1 group-hover:text-primary transition">
        {{tutorial.name}}
      </h2>
  
      <!-- DESCRIPTION -->
      <p class="text-xs-light line-clamp-2 mt-1 text-zinc-500">
        {{tutorial.description}}
      </p>
  
      <!-- ACTION BAR -->
      <div class="mt-auto pt-3 flex items-center justify-end gap-3 text-zinc-500">

        <!-- COPY LINK -->
        <button class="hover:text-primary" [appCopyToClipboard]="tutorial.videoURL" copyLabel="link" copyTooltip="Copy link">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
          </svg>
        </button>

        <button class="hover:text-primary" [appToolTip]="'Edit'" (click)="openTutorialEditModal(tutorial)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
          </svg>
        </button>
  
        <!-- DELETE -->
        <button class="hover:text-red-500 transition" [appToolTip]="'Delete'" (click)="deleteTutorial(tutorial.id)">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
            class="size-5">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
          </svg>
        </button>
  
      </div>
  
    </div>
  
  </div>
</div>

</section>

<app-tutorial-edit-modal *ngIf="tutorialModalObj" [tutorial]="tutorialModalObj"
  (onSave)="onSaveTutorial($event)" (onCloseModal)="onCloseTutorialModal()"></app-tutorial-edit-modal>